"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getServiceConfig = getServiceConfig;
exports.getJourneyPlannerHost = getJourneyPlannerHost;
exports.getGeocoderHost = getGeocoderHost;
exports.getNSRHost = getNSRHost;
exports.getScootersHost = getScootersHost;
exports.mergeConfig = mergeConfig;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HOST_CONFIG = {
  journeyPlanner: 'https://api.entur.io/journey-planner/v2',
  geocoder: 'https://api.entur.io/geocoder/v1',
  nsr: 'https://api.entur.io/stop-places/v1',
  scooters: 'https://api.entur.io/mobility/v1/scooters'
};

function getServiceConfig(config) {
  if (!config || !config.clientName) {
    throw new Error('ERROR: You must pass a "clientName" to EnturService through the config argument. ' + 'See https://www.entur.org/dev/api/header/ for information.\n');
  }

  var clientName = config.clientName,
      _config$hosts = config.hosts,
      hosts = _config$hosts === void 0 ? {} : _config$hosts,
      _config$headers = config.headers,
      headers = _config$headers === void 0 ? {} : _config$headers,
      fetch = config.fetch;
  return {
    clientName: clientName,
    headers: headers,
    hosts: _objectSpread(_objectSpread({}, HOST_CONFIG), hosts),
    fetch: fetch
  };
}

function getJourneyPlannerHost(_ref) {
  var hosts = _ref.hosts,
      clientName = _ref.clientName,
      headers = _ref.headers;
  return {
    host: hosts.journeyPlanner,
    headers: _objectSpread({
      'ET-Client-Name': clientName
    }, headers)
  };
}

function getGeocoderHost(_ref2) {
  var hosts = _ref2.hosts,
      clientName = _ref2.clientName,
      headers = _ref2.headers;
  return {
    host: hosts.geocoder,
    headers: _objectSpread({
      'ET-Client-Name': clientName
    }, headers)
  };
}

function getNSRHost(_ref3) {
  var hosts = _ref3.hosts,
      clientName = _ref3.clientName,
      headers = _ref3.headers;
  return {
    host: hosts.nsr,
    headers: _objectSpread({
      'ET-Client-Name': clientName
    }, headers)
  };
}

function getScootersHost(_ref4) {
  var hosts = _ref4.hosts,
      clientName = _ref4.clientName,
      headers = _ref4.headers;
  return {
    host: hosts.scooters,
    headers: _objectSpread({
      'ET-Client-Name': clientName
    }, headers)
  };
}

function mergeConfig(config, override) {
  if (!override) {
    return config;
  }

  return _objectSpread(_objectSpread({}, config), {}, {
    clientName: override.clientName || config.clientName,
    fetch: override.fetch || config.fetch,
    hosts: _objectSpread(_objectSpread({}, config.hosts), override.hosts),
    headers: _objectSpread(_objectSpread({}, config.headers), override.headers)
  });
}